
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire94c2"];
var parcelRegister = parcelRequire.register;
parcelRegister("bs4rl", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $8565c0f2319bb662$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $iCMjC = parcelRequire("iCMjC");

var $7xuAh = parcelRequire("7xuAh");
function $8565c0f2319bb662$export$2e2bcd8739ae039() {
    var teamMemberships = (0, $iCMjC.useAuthentication)().teamMemberships;
    if (!teamMemberships) return (0, $ayMG0.jsx)((0, $7xuAh.Redirect), {
        to: [
            "up.auth.login",
            {
                returnHere: false
            }
        ]
    });
    if (teamMemberships.every(function(membership) {
        return membership.isOwner && !membership.team.onboardingCompleted;
    })) return (0, $ayMG0.jsx)((0, $7xuAh.Redirect), {
        to: [
            "up.onboarding",
            {
                teamDomain: teamMemberships[0].team.domain
            }
        ]
    });
    var products = teamMemberships.flatMap(function(membership) {
        return membership.team.products;
    });
    switch(products[0]){
        case "helloscreen":
            return (0, $ayMG0.jsx)((0, $7xuAh.Redirect), {
                to: [
                    "hs.root",
                    {}
                ]
            });
        case "cobrowsingapi":
            return (0, $ayMG0.jsx)((0, $7xuAh.Redirect), {
                to: [
                    "co.root",
                    {}
                ]
            });
        case "livedocument":
            return (0, $ayMG0.jsx)((0, $7xuAh.Redirect), {
                to: [
                    "ld.root",
                    {}
                ]
            });
        case "userview":
            return (0, $ayMG0.jsx)((0, $7xuAh.Redirect), {
                to: [
                    "uv.root",
                    {}
                ]
            });
        default:
            return (0, $ayMG0.jsx)((0, $7xuAh.Redirect), {
                to: [
                    "up.onboarding.purchase",
                    {
                        teamDomain: teamMemberships[0].team.domain
                    }
                ]
            });
    }
}

});


//# sourceMappingURL=Root.04831aa2.js.map
